export const isNumeric = (n: unknown): boolean => !!Number(n);
